import { computed } from 'vue';
import { MediaThumbnails, MediaTypes } from '@/components/misc/media/constants';
import getImageUrl from './getImageUrl';
import { defaultThumbnailWidth } from './constants';

/**
 * This function determines the path of the picture to be previewed
 * @param {object} image Selected image
 * @param {function} getter This function checks if the picture has image, crops and path
 * @returns {string} path - Selected image path
 * @example {
 *    const selectedImage = {path:"somePath", crops:[{cropped images}]};
 *    const getterFn = (image) => image.value && image.value.crops && image.value.crops[0].path;
 *
 *    useThumbnail(selectedImage, getterFn);
 *
 *    return {(
 *      path ? `${process.env.VUE_APP_MEDIA_SERVER_URL}${somePath}` : MediaThumbnails[MediaTypes.IMAGE]);
 *    )};
 * }
 */

const useThumbnail = (image, getter) => computed(() => {
  const path = getter ? getter(image) : image.value;

  return (path
    ? getImageUrl(path, defaultThumbnailWidth)
    : MediaThumbnails[MediaTypes.IMAGE]);
});

export default useThumbnail;
